import { ReactNode, useContext } from 'react';

import BareLayout from 'packages/kakapo-ui-application/layouts/BareLayout';
import MainNavigationBar from 'packages/kakapo-ui-kit/components/navigation/MainNavigationBar';
import AuthorizationContext from 'packages/kakapo-ui-application/contexts/AuthorizationContext';

import useFeature from '../hooks/useFeature';

interface IProps {
	children: ReactNode;
	print?: boolean;
}

export default function MainLayout({ children, print }: IProps) {
	const authorizationContext = useContext(AuthorizationContext)!;

	const authenticatedUser = authorizationContext?.authenticatedUser;

	const adhocFeedback = useFeature('2021.feedback.adhoc');

	const callToActionButtonLink =
		authenticatedUser && adhocFeedback
			? `/user/${authenticatedUser.id}/feedback-v2/request-from-moment`
			: undefined;

	return (
		<BareLayout>
			{!print && (
				<MainNavigationBar
					user={authenticatedUser ?? null}
					callToActionButtonLink={callToActionButtonLink}
					renderMenuItems={() => <></>}
				/>
			)}
			{children}
		</BareLayout>
	);
}
